// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2WBw1","rootCenter":"LoadMoreObserver_rootCenter__1l7M9","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__35zWB"};